export default (params) => {
  const reopenRequestStatus =
    params.node && params.node.data
      ? params.node.data['reopenRequestStatusDescription']
      : null;

  return reopenRequestStatus ? reopenRequestStatus : 'N/A';
};
